// 遊び方ページ（/rules/）のスクリプト。対局盤を持たないので main.js は読まず、
// ページ共通の最低限（言語切替・☰メニュー・計測/広告・エラー収集）と、本文中の「触れる盤」を持つ。
// ルール判定は checkers.js（対局と同じもの）をそのまま使う。

(function () {
    'use strict';

    const C = window.Checkers;

    // ---- 早期エラー収集（main.js と同じ契約。feedback.js が読み込まれた時点で引き継ぐ） ----
    const MAX_EARLY_ERRORS = 3;
    window.__checkersEarlyErrors = [];

    function stackHead(error) {
        const stack = error && typeof error.stack === 'string' ? error.stack : '';
        if (!stack) return '';
        const frames = stack.split('\n').map(l => l.trim())
            .filter(l => l.startsWith('at ') || l.includes('@')).slice(0, 2)
            .map(l => l.replace(/https?:\/\/[^/]+/g, ''));
        return frames.length ? ` | ${frames.join(' < ')}` : '';
    }
    function recordEarlyError(source, message) {
        if (!message || !window.__checkersEarlyErrors) return;
        window.__checkersEarlyErrors.push({ source, message: String(message).slice(0, 300), at: Date.now() });
        if (window.__checkersEarlyErrors.length > MAX_EARLY_ERRORS) window.__checkersEarlyErrors.shift();
    }
    window.addEventListener('error', e => {
        const where = e.filename ? ` @${String(e.filename).split('/').pop()}:${e.lineno}:${e.colno || 0}` : '';
        recordEarlyError('error', (e.message || 'error') + where + stackHead(e.error));
    });
    window.addEventListener('unhandledrejection', e => {
        recordEarlyError('promise', ((e.reason && e.reason.message) || e.reason || 'unhandledrejection') + stackHead(e.reason));
    });

    // ---- 計測と広告（main.js と同じく load 後に読む）----
    const GA_ID = 'G-29HQ99PYVJ';
    const AD_CLIENT = 'ca-pub-1918692579240633';

    function whenIdle(task, timeout = 2000) {
        if (typeof requestIdleCallback === 'function') requestIdleCallback(task, timeout ? { timeout } : undefined);
        else setTimeout(task, 0);
    }
    const FEEDBACK_SCRIPT_SRC = '/feedback.js';
    const loadedScripts = new Map();
    function loadScriptOnce(src) {
        if (!loadedScripts.has(src)) {
            loadedScripts.set(src, new Promise((resolve, reject) => {
                const script = document.createElement('script');
                script.src = src;
                script.onload = () => resolve();
                script.onerror = () => { loadedScripts.delete(src); reject(new Error(`Failed to load ${src}`)); };
                document.head.appendChild(script);
            }));
        }
        return loadedScripts.get(src);
    }

    // ---- ☰メニュー（このページには盤用モーダルが無いので、必要な分だけ持つ）----
    let openModalEl = null;
    let modalOpener = null;

    function openModal(modal) {
        modalOpener = document.activeElement;
        modal.hidden = false;
        openModalEl = modal;
        const focusTarget = modal.querySelector('.btn.pri, textarea, button');
        if (focusTarget) focusTarget.focus({ preventScroll: true });
    }
    function closeModal(modal) {
        if (!modal || modal.hidden) return;
        modal.hidden = true;
        if (openModalEl === modal) openModalEl = null;
        if (modalOpener && typeof modalOpener.focus === 'function') modalOpener.focus({ preventScroll: true });
    }
    function setupModalBasics(modal) {
        modal.addEventListener('click', e => { if (e.target === modal) closeModal(modal); });
        modal.addEventListener('keydown', e => {
            if (e.key !== 'Tab') return;
            const focusables = Array.from(modal.querySelectorAll('button, [href], select, textarea, input:not(.feedback-honeypot)'))
                .filter(el => !el.disabled && !el.hidden && el.offsetParent !== null);
            if (focusables.length === 0) return;
            const first = focusables[0], last = focusables[focusables.length - 1];
            if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
            else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
        });
    }
    document.addEventListener('keydown', e => {
        if (e.key === 'Escape' && openModalEl) { e.stopPropagation(); closeModal(openModalEl); }
    }, true);

    function setupMenu() {
        const modal = document.getElementById('menu-modal');
        const button = document.getElementById('menu-button');
        if (!modal || !button) return;
        setupModalBasics(modal);
        button.addEventListener('click', () => openModal(modal));
        document.getElementById('close-menu').addEventListener('click', () => closeModal(modal));
        document.getElementById('menu-how-to-play').addEventListener('click', () => closeModal(modal));
        document.getElementById('menu-feedback').addEventListener('click', () => {
            closeModal(modal);
            loadScriptOnce(FEEDBACK_SCRIPT_SRC).then(() => window.checkersFeedback && window.checkersFeedback.open()).catch(() => {});
        });
    }

    // フィードバックに添える情報。このページに対局は無いのでモード名だけ
    window.checkersFeedbackContext = () => ({ mode: 'rules' });

    // ---- 本文中の「触れる盤」 ------------------------------------------------
    // build.mjs / main.js の CROWN_SVG と同じ文字列（test/build-pages.test.js が検証）
    const CROWN_SVG = '<svg class="crown" viewBox="0 0 24 24" aria-hidden="true"><path d="M4 17h16l1.2-9-4.6 3.4L12 5l-4.6 6.4L2.8 8z" fill="currentColor"/><rect x="4" y="18.5" width="16" height="2" rx="1" fill="currentColor"/></svg>';
    const reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    const HOP_MS = reduceMotion ? 0 : 210;

    // 局面は8行×8文字（'.'=空 / b=黒 / B=黒キング / r=赤 / R=赤キング）。黒が手前・先手
    function parsePos(text) {
        const rows = text.trim().split(/\s+/);
        let b = 0, r = 0, k = 0;
        for (let row = 0; row < 8; row++) {
            for (let col = 0; col < 8; col++) {
                const ch = rows[row][col];
                const s = C.squareAt(row, col);
                if (ch === '.' || s < 0) continue;
                const mask = 1 << s;
                if (ch === 'b' || ch === 'B') b |= mask; else r |= mask;
                if (ch === 'B' || ch === 'R') k |= mask;
            }
        }
        return { b, r, k, side: C.BLACK, quiet: 0 };
    }
    function pieceAt(state, s) {
        const mask = 1 << s;
        if (state.b & mask) return { color: 'black', king: (state.k & mask) !== 0 };
        if (state.r & mask) return { color: 'red', king: (state.k & mask) !== 0 };
        return null;
    }
    function legalMoves(state) {
        return C.generateMoves(state.b, state.r, state.k, state.side, true);
    }
    // 1跳びで飛び越したマス（着地点と出発点の中間）
    function jumpedSquare(from, to) {
        if (Math.abs(C.SQ_ROW[to] - C.SQ_ROW[from]) !== 2) return -1;
        return C.squareAt((C.SQ_ROW[from] + C.SQ_ROW[to]) / 2, (C.SQ_COL[from] + C.SQ_COL[to]) / 2);
    }
    // 連続ジャンプの途中経過。1跳びだけ進めた局面を返す（手番はそのまま）
    function hopState(state, from, to) {
        const fromBit = 1 << from, toBit = 1 << to;
        let b = state.b, r = state.r, k = state.k;
        const wasKing = (k & fromBit) !== 0;
        if (b & fromBit) b = (b & ~fromBit) | toBit; else r = (r & ~fromBit) | toBit;
        k &= ~fromBit;
        if (wasKing) k |= toBit;
        const jumped = jumpedSquare(from, to);
        if (jumped >= 0) {
            const jumpedBit = 1 << jumped;
            b &= ~jumpedBit; r &= ~jumpedBit; k &= ~jumpedBit;
        }
        return { b, r, k, side: state.side, quiet: 0 };
    }
    // マス目のマークアップは build.mjs / main.js と同じ（class の並びも揃える）
    function render(boardEl, state, hl) {
        hl = hl || {};
        let html = '';
        for (let row = 0; row < 8; row++) {
            for (let col = 0; col < 8; col++) {
                const s = C.squareAt(row, col);
                if (s < 0) { html += '<div class="sq l"></div>'; continue; }
                let cls = 'sq d';
                if (hl.sel === s) cls += ' sel';
                if (hl.targets && hl.targets.has(s)) cls += ' tgt';
                if (hl.glow && hl.glow.has(s)) cls += ' mv';
                if (hl.shake === s) cls += ' shake';
                const piece = pieceAt(state, s);
                let inner = '';
                if (piece) {
                    let pcls = 'pc ' + (piece.color === 'black' ? 'blk' : 'red') + (piece.king ? ' king' : '');
                    if (hl.captured && hl.captured.has(s)) pcls += ' cap';
                    if (hl.promoted === s) pcls += ' promo';
                    inner = `<span class="${pcls}">${piece.king ? CROWN_SVG : ''}</span>`;
                } else if (hl.targets && hl.targets.has(s)) {
                    inner = '<span class="dot"></span>';
                }
                html += `<div class="${cls}" data-sq="${s}">${inner}</div>`;
            }
        }
        boardEl.innerHTML = html;
    }

    // 駒を選んで動かす盤。data-* に局面と文言を持つ（文言は本文と同じ辞書＝パーシャル側にある）
    function setupTryBoard(widget) {
        const boardEl = widget.querySelector('[data-board]');
        const msgEl = widget.querySelector('[data-msg]');
        const chips = Array.from(widget.querySelectorAll('.rl-chip'));
        let source = chips.length > 0 ? chips[0] : widget;
        // data-goal は「その盤で見せたい手」。達成したら done を出し、リセットするまで操作を止める
        // （そのあとも動かせると、達成したときの文言が盤の中身と合わなくなる）
        const goal = widget.getAttribute('data-goal');
        let state = null, moves = [], selected = -1, targets = null, glowing = false;
        let done = false, locked = false, busy = false, generation = 0;

        // 文言はチップ（駒の種類）側を優先し、無ければ盤ごとの既定を使う
        const text = name => source.getAttribute(`data-${name}`) || widget.getAttribute(`data-${name}`) || '';
        function say(message, kind) {
            // 同じ文字列でも代入すると読み上げが走るので、変わるときだけ書き換える
            if (msgEl.textContent !== message) msgEl.textContent = message;
            msgEl.className = 'rl-msg' + (kind ? ' ' + kind : '');
        }
        function achieved(move) {
            if (goal === 'capture') return move.caps.length > 0;
            if (goal === 'promote') return move.promote;
            return false; // 自由に動かす盤（動かし方の説明）は止めない
        }
        function paint(extra) {
            const hl = {
                sel: selected,
                targets: targets ? new Set(targets.keys()) : null,
                glow: glowing ? new Set(moves.map(m => m.from)) : null
            };
            render(boardEl, state, Object.assign(hl, extra || {}));
        }
        function reset() {
            generation++;
            state = parsePos(source.getAttribute('data-pos'));
            moves = legalMoves(state);
            selected = -1; targets = null; glowing = false; done = false; locked = false; busy = false;
            widget.classList.remove('is-done');
            say(source.getAttribute('data-start') || '');
            paint();
        }
        function play(move) {
            const myTurn = ++generation; // リセットされたら、保留中の1跳びは捨てる
            busy = true; selected = -1; targets = null; glowing = false;
            const finalState = C.applyMove(state, move);
            finalState.side = C.BLACK; // 説明用の盤なので、手番は黒のままにして何度でも試せるようにする
            let hop = 1;
            const step = () => {
                if (myTurn !== generation) return;
                const from = move.path[hop - 1], to = move.path[hop];
                const last = hop === move.path.length - 1;
                state = last ? finalState : hopState(state, from, to);
                render(boardEl, state, { promoted: (last && move.promote) ? move.to : -1 });
                hop++;
                if (hop < move.path.length) { setTimeout(step, HOP_MS); return; }
                moves = legalMoves(state);
                busy = false;
                if (done) {                      // 昇格のあとにキングを動かしたときの一言
                    say(text('done2') || text('done'), 'ok');
                    locked = true;
                } else if (!goal || achieved(move)) {
                    say(text('done'), 'ok');
                    done = Boolean(goal);
                    locked = done && !widget.hasAttribute('data-done2');
                } else {
                    say(text('start'));          // 目的の手ではなかったとき（局面を変えたときの保険）
                }
                widget.classList.toggle('is-done', locked);
            };
            setTimeout(step, 10);
        }

        boardEl.addEventListener('click', e => {
            if (busy || locked) return;
            const cell = e.target.closest('[data-sq]');
            if (!cell) return;
            const square = Number(cell.dataset.sq);
            if (targets && targets.has(square)) { play(targets.get(square)); return; }
            const fromHere = moves.filter(m => m.from === square);
            if (fromHere.length > 0) {
                selected = square;
                targets = new Map(fromHere.map(m => [m.to, m]));
                const captured = new Set();
                for (const m of fromHere) for (const c of m.caps) captured.add(c);
                // 案内は「選んだ駒でいま何ができるか」で決める。駒の種類（チップ）だけで決めると、
                // 自由に動かせる盤で取り強制が起きたとき、丸（ジャンプの着地点）と説明が食い違う
                const jumping = fromHere.some(m => m.caps.length > 0);
                const king = pieceAt(state, square).king;
                say((done && text('pick2')) || (jumping && text('pick-jump')) || (king && text('pick-king')) || text('pick'));
                paint({ captured });
                return;
            }
            selected = -1; targets = null;
            const piece = pieceAt(state, square);
            if (piece && piece.color === 'black') {
                // 動かせない理由は2つ（取れる駒が他にある／進める先がふさがっている）ので、文言を分ける
                const capturing = moves.some(m => m.caps.length > 0);
                const why = (capturing && widget.getAttribute('data-wrong')) || widget.getAttribute('data-blocked');
                if (why) {
                    glowing = capturing && widget.hasAttribute('data-glow');
                    say(why, 'ng');
                    paint({ shake: square });
                    return;
                }
            }
            if (!glowing) say(done ? text('done') : (source.getAttribute('data-start') || ''), done ? 'ok' : '');
            paint();
        });
        chips.forEach(chip => {
            chip.addEventListener('click', () => {
                for (const other of chips) other.setAttribute('aria-pressed', String(other === chip));
                source = chip;
                reset();
            });
        });
        const resetButton = widget.querySelector('[data-reset]');
        if (resetButton) resetButton.addEventListener('click', reset);
        reset();
    }

    // 手順を1手ずつ見せる盤（1対2の交換）
    function setupReplayBoard(widget) {
        const boardEl = widget.querySelector('[data-board]');
        const msgEl = widget.querySelector('[data-msg]');
        const steps = Array.from(widget.querySelectorAll('[data-steps] li'));
        const progressEl = widget.querySelector('[data-prog]');
        const prevButton = widget.querySelector('[data-prev]');
        const nextButton = widget.querySelector('[data-next]');
        const square = text => {
            const [row, col] = text.split(',').map(Number);
            return C.squareAt(row, col);
        };
        const sequence = widget.getAttribute('data-seq').split('|').map(part => {
            const [from, to] = part.split('>');
            return { from: square(from), to: square(to) };
        });
        const states = [parsePos(widget.getAttribute('data-pos'))];
        let index = 0, busy = false;

        function moveAt(i) {
            const want = sequence[i];
            return legalMoves(states[i]).find(m => m.from === want.from && m.to === want.to) || null;
        }
        function sync() {
            steps.forEach((li, i) => li.classList.toggle('on', i === index - 1));
            progressEl.textContent = `${index} / ${sequence.length}`;
            prevButton.disabled = index === 0;
            nextButton.disabled = index === sequence.length;
            const done = index === sequence.length;
            msgEl.textContent = done ? (widget.getAttribute('data-done') || '') : '';
            msgEl.className = 'rl-msg' + (done ? ' ok' : '');
        }
        nextButton.addEventListener('click', () => {
            if (busy || index === sequence.length) return;
            const move = moveAt(index);
            if (!move) return;
            busy = true;
            let state = states[index], hop = 1;
            const step = () => {
                const from = move.path[hop - 1], to = move.path[hop];
                const last = hop === move.path.length - 1;
                state = last ? C.applyMove(states[index], move) : hopState(state, from, to);
                render(boardEl, state, { promoted: (last && move.promote) ? move.to : -1 });
                hop++;
                if (hop < move.path.length) { setTimeout(step, HOP_MS); return; }
                states[index + 1] = state;
                index++;
                busy = false;
                sync();
            };
            setTimeout(step, 10);
        });
        prevButton.addEventListener('click', () => {
            if (busy || index === 0) return;
            index--;
            render(boardEl, states[index], {});
            sync();
        });
        render(boardEl, states[0], {});
        sync();
    }

    function setupBoards() {
        for (const widget of document.querySelectorAll('[data-try]')) {
            if (widget.getAttribute('data-try') === 'replay') setupReplayBoard(widget);
            else setupTryBoard(widget);
        }
    }

    function setupLanguageSwitcher() {
        const select = document.getElementById('lang-switcher');
        if (select) select.addEventListener('change', e => { if (e.target.value) location.href = e.target.value; });
    }

    window.addEventListener('load', () => {
        if (GA_ID) {
            const script = document.createElement('script');
            script.async = true;
            script.src = `https://www.googletagmanager.com/gtag/js?id=${GA_ID}`;
            document.head.appendChild(script);
            window.dataLayer = window.dataLayer || [];
            window.gtag = function () { window.dataLayer.push(arguments); };
            window.gtag('js', new Date());
            window.gtag('config', GA_ID);
        }
        const adsScript = document.createElement('script');
        adsScript.async = true;
        adsScript.src = `https://pagead2.googlesyndication.com/pagead/js/adsbygoogle.js?client=${AD_CLIENT}`;
        adsScript.crossOrigin = 'anonymous';
        document.head.appendChild(adsScript);
        whenIdle(() => { loadScriptOnce(FEEDBACK_SCRIPT_SRC).catch(() => {}); });
    });

    function init() {
        setupLanguageSwitcher();
        setupMenu();
        setupBoards();
    }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
    else init();
})();
